<template>
<div>
  <div class="container-title">
    {{ $t('sale_invoices.singular') }}
  </div>
  <b-card no-body>
    <b-card-body>
      <div class="row">
        <div class="col-12">
            <b-table-simple class="resume-table" style="margin: 0" borderless outlined responsive>
              <b-thead>
                <b-tr>
                  <b-td style="width: 200px">{{ lodash.startCase($t('sale_notes.resumes.sales_number')) }}</b-td>
                  <b-td style="width: 150px">{{ lodash.startCase($t('sale_notes.resumes.receipt_date')) }}</b-td>
                  <b-td style="text-align: right">{{ lodash.startCase($t('sale_notes.resumes.nominal')) }}</b-td>
                  <b-td>{{ lodash.startCase($t('sale_notes.resumes.sender')) }}</b-td>
                  <b-td>{{ lodash.startCase($t('sale_notes.resumes.recipient')) }}</b-td>
                </b-tr>
              </b-thead>
              <b-tbody>
                <template v-if="tableItems.length > 0">
                  <b-tr v-for="({
                  invoice_number,
                  paid_at,
                  paid_off_label,
                  nominal,
                  from,
                  to,
                  }, index) in tableItems" :key="index">
                    <b-td>{{ invoice_number }}</b-td>
                    <b-td>{{ $moment.utc(paid_at).local().format('d MMMM YYYY') }}</b-td>
                    <b-td style="text-align: right">{{ currencyFormatter(nominal) }}<span v-if="paid_off_label" class="text-success" style="padding-left: 8px">{{ lodash.upperFirst($t('paid_off')) }}</span></b-td>
                    <b-td v-html="from"/>
                    <b-td v-html="to"/>
                  </b-tr>
                </template>
                <template v-else>
                  <b-tr>
                    <b-td colspan="5" style="text-align: center">{{ lodash.upperFirst($t('sale_notes.resumes.there is no data yet')) }}</b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
        </div>
      </div>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
export default {
  name: 'sale-payment',
  props: {
    value: { type: Object, default: function () { return {} }},
  },
  computed: {
    tableItems() {
      let remaining_receivable = this.value.total

      return this.value?.payments?.map(({
        invoice_number,
        paid_at,
        nominal,
        from_bank_account,
        to_bank_account,
      }) => {
        remaining_receivable -= nominal
        return {
          invoice_number,
          paid_at,
          paid_off_label: remaining_receivable <= 0,
          nominal,
          from: `${from_bank_account.customer.name}<br>${from_bank_account.account_number}<br>${from_bank_account.bank.name}`,
          to: `${to_bank_account.customer.name}<br>${to_bank_account.account_number}<br>${to_bank_account.bank.name}`
        }
      }) ?? []
    }
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
  }
}
</script>

<style scoped>

</style>